

import React, { Component } from 'react';
import close from './../../../assets/images/close.svg';

export default class PopUpCustomAll extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
        }
    }

    

render() {
    return (
            <div className="delete_popup_wrapper">
                {/* <span className="popup_overlay"></span> */}
                <div className="popup_inner">
                    <h2 className="popup_title text_center relative">
                   {this.props.HeaderName}
                        <img src={close} onClick={this.props.popupState} />
                    </h2>
                    <div className="details">
                        <h3 className="detail_title text_center mb_15">{this.props.insideDetails}</h3>
                        <h3 className="detail_title text_center mb_15">{this.props.insideMobileDetails}</h3>
                        <h3 className="detail_title_bold text_center pb_25">{this.props.insideData}</h3>
                        <div className="content_management">
                            <div className="field_row text_center">
                                <button className="orangeBTN active" type="button" onClick={this.props.popupState}>NO</button>
                                <button className="grayBTN" type="button" disabled={this.props.isDisable} onClick={this.props.yesPopUp}>{this.props.sendNotification? "Send Notification" :'YES'}</button>
                                {/* <button className="grayBTN" type="button" onClick={this.props.SendNotification}>Send Notification</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>       
        )
    }   
}
